"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UI_1 = require("./UI");
var Storage_1 = require("./Storage");
var DOM = /** @class */ (function () {
    function DOM() {
    }
    // for deleting current card from modal
    DOM.modalDeleteListener = function () {
        var deleteBtn = document.querySelector(".modal>.delete"); //
        deleteBtn.addEventListener("click", function () {
            var list = DOM.lastCard.parentNode;
            var listIndex = parseInt(list.dataset.index);
            var cardIndex = parseInt(DOM.lastCard.dataset.index);
            var board = list.parentNode;
            var boardIndex = parseInt(board.dataset.index);
            var modalWrapper = document.querySelector(".modalWrapper");
            modalWrapper.style.display = "none";
            // delete card from list in DOM
            list.removeChild(DOM.lastCard);
            // update storage
            Storage_1.default.removeCard(cardIndex, listIndex, boardIndex);
        });
    };
    // for changing name of card from modal
    DOM.modalTitleListener = function () {
        var cardTitleText = document.querySelector("h2.title");
        var cardTitleInput = document.querySelector("input.title");
        DOM.attachInputListener(cardTitleText, cardTitleInput, function () {
            var newTitle = cardTitleInput.value;
            var list = DOM.lastCard.parentNode;
            var cardIndex = parseInt(DOM.lastCard.dataset.index);
            var listIndex = parseInt(list.dataset.index);
            var board = list.parentNode;
            var boardIndex = parseInt(board.dataset.index);
            var title = DOM.lastCard.querySelector("h3");
            // change card title in modal
            cardTitleText.textContent = newTitle;
            // change card title in list
            title.textContent = newTitle;
            // update storage
            Storage_1.default.changeCardTitle(newTitle, cardIndex, listIndex, boardIndex);
        }, false);
    };
    DOM.updateIndexes = function (parentNode) {
        // everytime you delete/move element in DOM, the indexes
        // need to be updated to match the storage
        // to prevent indexes going: "0, 1, 3, 4, 5"
        var elements = parentNode.querySelectorAll(":scope > [data-index]");
        elements.forEach(function (element, newIndex) {
            element.dataset.index = String(newIndex);
        });
    };
    DOM.attachInputListener = function (textElement, inputElement, processCallback, wipeInput) {
        if (wipeInput === void 0) { wipeInput = true; }
        // Event listener that dynamically swaps visibility of
        // text element to input element when you click on text element.
        // When you lose focus or press enter, it executes the callback
        // function and swaps back to text element.
        textElement.addEventListener("click", function () {
            function sendInput() {
                if (inputElement.value !== "") {
                    textElement.classList.remove("active");
                    inputElement.classList.remove("active");
                    processCallback();
                    if (wipeInput) {
                        // wipe out the input by default, so you always start fresh
                        inputElement.value = "";
                    }
                }
                else {
                    textElement.classList.remove("active");
                    inputElement.classList.remove("active");
                }
            }
            // hides the text, shows the input and focuses it
            textElement.classList.add("active");
            inputElement.classList.add("active");
            inputElement.focus();
            // when you lose focus by clicking somewhere outside the input
            inputElement.onblur = function () {
                sendInput();
            };
            inputElement.onkeydown = function (e) {
                if (e.key === "Enter") {
                    sendInput();
                }
                if (e.key === "Escape") {
                    inputElement.value = "";
                    sendInput();
                    if (!wipeInput) {
                        // reset the input to whatever was the previous text
                        inputElement.value = textElement.textContent;
                    }
                }
            };
        });
    };
    DOM.moveListListener = function (directionBtn) {
        directionBtn.addEventListener("click", function () {
            var list = directionBtn.parentNode;
            var listIndex = parseInt(list.dataset.index, 10);
            var lists = document.querySelectorAll(".list");
            var direction = directionBtn.classList[0];
            // also makes sure you don't exceed array range
            if (direction === "moveBackBtn" && listIndex > 0) {
                Storage_1.default.moveList(listIndex, listIndex - 1, UI_1.default.currentBoardIndex);
                list.parentNode.insertBefore(list, lists[listIndex - 1]);
            }
            else if (direction === "moveForwardBtn" && listIndex < lists.length) {
                Storage_1.default.moveList(listIndex, listIndex + 1, UI_1.default.currentBoardIndex);
                list.parentNode.insertBefore(list, lists[listIndex + 2]);
            }
            DOM.updateIndexes(list.parentNode);
        });
    };
    DOM.moveCardListener = function (directionBtn) {
        directionBtn.addEventListener("click", function () {
            var card = directionBtn.parentNode;
            var cardIndex = parseInt(card.dataset.index, 10);
            var cards = card.parentNode.querySelectorAll(".card");
            var list = card.parentNode;
            var listIndex = parseInt(list.dataset.index, 10);
            var direction = directionBtn.classList[0];
            // also makes sure you don't exceed array range
            if (direction === "moveUpBtn" && cardIndex > 0) {
                Storage_1.default.moveCard(cardIndex, cardIndex - 1, listIndex, UI_1.default.currentBoardIndex);
                card.parentNode.insertBefore(card, cards[cardIndex - 1]);
            }
            else if (direction === "moveDownBtn" && cardIndex < cards.length) {
                Storage_1.default.moveCard(cardIndex, cardIndex + 1, listIndex, UI_1.default.currentBoardIndex);
                card.parentNode.insertBefore(card, cards[cardIndex + 2]);
            }
            DOM.updateIndexes(card.parentNode);
        });
    };
    DOM.createSVG = function (customPath) {
        var SVG_NS = "http://www.w3.org/2000/svg";
        var SVGElement = document.createElementNS(SVG_NS, "svg");
        SVGElement.setAttribute("viewBox", "0 0 24 24");
        var SVGPathElement = document.createElementNS(SVG_NS, "path");
        SVGPathElement.setAttribute("fill", "currentColor");
        SVGPathElement.setAttribute("d", customPath);
        SVGElement.appendChild(SVGPathElement);
        return SVGElement;
    };
    DOM.createKebabMenu = function (kebabBtn) {
        var kebabMenu = document.createElement("div");
        kebabMenu.classList.add("menu");
        var removeBtn = document.createElement("button");
        removeBtn.textContent = "Remove this list";
        removeBtn.classList.add("removeList");
        kebabMenu.appendChild(removeBtn);
        kebabBtn.parentNode.appendChild(kebabMenu);
        // delete list button
        removeBtn.onmousedown = function (event) {
            // blur event would result in this listener being removed before
            // execution, so we prevent the blur and execute this listener's callback
            event.preventDefault();
            // remove the list from DOM and from Storage
            var list = kebabBtn.parentNode;
            var listIndex = parseInt(list.dataset.index);
            list.remove();
            Storage_1.default.removeList(listIndex, UI_1.default.currentBoardIndex);
            var board = document.querySelector(".board");
            DOM.updateIndexes(board);
        };
        function closeMenu() {
            // remove the menu from DOM
            kebabMenu.remove();
            // add the original listener to kebab button again
            kebabBtn.onclick = function () {
                DOM.createKebabMenu(kebabBtn);
            };
        }
        // close menu when you lose focus or click the kebab button again
        kebabBtn.onblur = function () {
            closeMenu();
        };
        kebabBtn.onclick = function () {
            closeMenu();
        };
    };
    DOM.sidebarSwipeListener = function () {
        // hide sidebar when you swipe left
        // show sidebar when you swipe right (and you are on left side of page)
        var mainNode = document.querySelector("main");
        var touchStartX = 0;
        var touchEndX = 0;
        var scrollLeftStart;
        function checkDirection() {
            var sidebar = document.querySelector(".sidebar");
            // swiped left
            if (touchEndX < touchStartX) {
                sidebar.classList.add("hidden");
            }
            // swiped right
            if (touchEndX > touchStartX) {
                // only if you are scrolled to the left side of page
                if (scrollLeftStart === 0) {
                    sidebar.classList.remove("hidden");
                }
            }
        }
        document.addEventListener("touchstart", function (e) {
            touchStartX = e.changedTouches[0].screenX;
            scrollLeftStart = mainNode.scrollLeft;
        });
        document.addEventListener("touchend", function (e) {
            touchEndX = e.changedTouches[0].screenX;
            checkDirection();
        });
    };
    // boards manipulation
    DOM.createBoardBtn = function (boardIndex) {
        var boardBtn = document.createElement("button");
        var name = Storage_1.default.boards[boardIndex].name;
        boardBtn.textContent = name;
        boardBtn.dataset.index = String(boardIndex);
        DOM.sidebar.appendChild(boardBtn);
        boardBtn.addEventListener("click", function (e) {
            var clickedBoard = e.target;
            var clickedBoardIndex = parseInt(clickedBoard.dataset.index);
            // update and save new current board index
            UI_1.default.currentBoardIndex = clickedBoardIndex;
            Storage_1.default.setLocalStorage();
            DOM.constructBoard(clickedBoardIndex);
        });
    };
    DOM.createBoard = function (boardIndex) {
        DOM.wipeBoard();
        var boardName = Storage_1.default.boards[boardIndex].name;
        var heading = document.createElement("h1");
        var renameInput = document.createElement("input");
        heading.classList.add("dynamicText");
        heading.textContent = boardName;
        DOM.currentBoard.appendChild(heading);
        renameInput.setAttribute("type", "text");
        renameInput.classList.add("rename", "dynamicInput");
        renameInput.value = boardName;
        DOM.currentBoard.appendChild(renameInput);
        DOM.attachInputListener(heading, renameInput, function () {
            var newName = renameInput.value;
            var clickedHeading = DOM.currentBoard.querySelector("h1");
            clickedHeading.textContent = newName;
            var clickedBoardIndex = UI_1.default.currentBoardIndex;
            var boardLink = document.querySelector(".sidebar>button[data-index=\"".concat(clickedBoardIndex, "\"]"));
            boardLink.textContent = newName;
            Storage_1.default.changeBoardName(newName, clickedBoardIndex);
        }, false);
        var deleteBtn = document.createElement("button");
        deleteBtn.classList.add("delete");
        deleteBtn.textContent = "Delete board";
        deleteBtn.addEventListener("click", function () {
            DOM.wipeBoard();
            var clickedBoardIndex = UI_1.default.currentBoardIndex;
            var boardLink = document.querySelector(".sidebar>button[data-index=\"".concat(clickedBoardIndex, "\"]"));
            boardLink.remove();
            // to prevent staying at undefined index when
            // when last item is deleted
            UI_1.default.currentBoardIndex = Storage_1.default.boards.length - 2;
            if (UI_1.default.currentBoardIndex < 0) {
                UI_1.default.currentBoardIndex = undefined;
            }
            DOM.updateIndexes(DOM.sidebar);
            Storage_1.default.deleteBoard(clickedBoardIndex);
        });
        DOM.currentBoard.appendChild(deleteBtn);
        var board = document.createElement("div");
        board.classList.add("board");
        board.dataset.index = String(boardIndex);
        DOM.currentBoard.appendChild(board);
        var newListBtn = document.createElement("button");
        var newListInput = document.createElement("input");
        newListBtn.classList.add("newList", "dynamicText");
        newListBtn.textContent = "+ Add another list";
        board.appendChild(newListBtn);
        newListInput.setAttribute("type", "text");
        newListInput.classList.add("newList", "dynamicInput");
        board.appendChild(newListInput);
        DOM.attachInputListener(newListBtn, newListInput, function () {
            var listName = newListInput.value;
            Storage_1.default.createList(listName, UI_1.default.currentBoardIndex);
            var newListIndex = Storage_1.default.boards[UI_1.default.currentBoardIndex].lists.length - 1;
            DOM.createList(UI_1.default.currentBoardIndex, newListIndex);
        });
    };
    DOM.wipeBoard = function () {
        DOM.currentBoard.textContent = "";
    };
    // constructs the whole board, including all lists and cards
    DOM.constructBoard = function (boardIndex) {
        // reconstruct last selected board
        DOM.createBoard(boardIndex);
        // reconstruct lists
        var currentBoard = Storage_1.default.boards[boardIndex];
        currentBoard.lists.forEach(function (list, listIndex) {
            DOM.createList(boardIndex, listIndex);
            // reconstruct cards
            list.cards.forEach(function (card, cardIndex) {
                DOM.createCard(boardIndex, listIndex, cardIndex);
            });
        });
    };
    // lists manipulation
    DOM.createList = function (boardIndex, listIndex) {
        var board = document.querySelector(".board");
        var list = document.createElement("div");
        list.classList.add("list");
        list.dataset.index = String(listIndex);
        board.appendChild(list);
        var moveBackBtn = document.createElement("button");
        moveBackBtn.appendChild(DOM.createSVG(DOM.svgArrowsPaths[3]));
        moveBackBtn.classList.add("moveBackBtn");
        DOM.moveListListener(moveBackBtn);
        list.appendChild(moveBackBtn);
        var heading = document.createElement("h2");
        var headingInput = document.createElement("input");
        var name = Storage_1.default.boards[boardIndex].lists[listIndex].name;
        heading.classList.add("dynamicText");
        heading.textContent = name;
        list.appendChild(heading);
        headingInput.setAttribute("type", "text");
        headingInput.classList.add("headingInput", "dynamicInput");
        headingInput.value = name;
        list.appendChild(headingInput);
        DOM.attachInputListener(heading, headingInput, function () {
            var newName = headingInput.value;
            heading.textContent = newName;
            var selectedListIndex = parseInt(list.dataset.index);
            Storage_1.default.changeListName(newName, selectedListIndex, UI_1.default.currentBoardIndex);
        }, false);
        var moveForwardBtn = document.createElement("button");
        moveForwardBtn.appendChild(DOM.createSVG(DOM.svgArrowsPaths[1]));
        moveForwardBtn.classList.add("moveForwardBtn");
        DOM.moveListListener(moveForwardBtn);
        list.appendChild(moveForwardBtn);
        var newCardBtn = document.createElement("button");
        var newCardInput = document.createElement("input");
        newCardBtn.classList.add("newCard", "dynamicText");
        newCardBtn.textContent = "+ Add a card";
        list.appendChild(newCardBtn);
        newCardInput.setAttribute("type", "text");
        newCardInput.classList.add("newCardInput", "dynamicInput");
        list.appendChild(newCardInput);
        DOM.attachInputListener(newCardBtn, newCardInput, function () {
            var cardName = newCardInput.value;
            var cardDescription = "";
            var cardPriority = 0;
            var clickedListIndex = parseInt(list.dataset.index);
            Storage_1.default.createCard(cardName, cardDescription, cardPriority, clickedListIndex, UI_1.default.currentBoardIndex);
            var newCardIndex = Storage_1.default.boards[UI_1.default.currentBoardIndex].lists[clickedListIndex].cards
                .length - 1;
            DOM.createCard(UI_1.default.currentBoardIndex, clickedListIndex, newCardIndex);
        });
        var kebabBtn = document.createElement("button");
        kebabBtn.classList.add("kebabBtn");
        kebabBtn.appendChild(DOM.createSVG("M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"));
        kebabBtn.onclick = function () {
            DOM.createKebabMenu(kebabBtn);
        };
        list.appendChild(kebabBtn);
    };
    // cards manipulation
    DOM.createCard = function (boardIndex, listIndex, cardIndex) {
        var list = document.querySelector(".list[data-index=\"".concat(listIndex, "\"]"));
        var card = document.createElement("div");
        card.classList.add("card");
        card.dataset.index = String(cardIndex);
        list.appendChild(card);
        var cardObject = Storage_1.default.boards[boardIndex].lists[listIndex].cards[cardIndex];
        var title = document.createElement("h3"); // the clickable "card" part of the card
        title.textContent = cardObject.title;
        // show modal when card is clicked
        title.addEventListener("click", function (e) {
            var modal = document.querySelector(".modalWrapper");
            var clickedCardIndex = parseInt(card.dataset.index);
            var clickedListIndex = parseInt(list.dataset.index);
            // update the last clicked card
            var clickedCard = e.target.parentNode;
            DOM.lastCard = clickedCard;
            // populate the modal with current card's properties
            // and fill inputs with the properties too
            var cardTitleText = modal.querySelector("h2.title");
            var cardTitleInput = modal.querySelector("input.title");
            cardTitleText.textContent = cardObject.title;
            cardTitleInput.value = cardObject.title;
            var cardDescriptionText = modal.querySelector("p.description.dynamicText");
            var cardDescriptionInput = modal.querySelector("textarea.description");
            cardDescriptionText.textContent = cardObject.description;
            cardDescriptionInput.value = cardObject.description;
            if (cardObject.description === "") {
                cardDescriptionText.textContent = "Add a more detailed description...";
            }
            // make modal visible
            modal.style.display = "flex";
            // dynamic input for description
            DOM.attachInputListener(cardDescriptionText, cardDescriptionInput, function () {
                var newDescription = cardDescriptionInput.value;
                // change description in modal
                cardDescriptionText.textContent = newDescription;
                // update storage
                Storage_1.default.changeCardDescription(newDescription, clickedCardIndex, clickedListIndex, UI_1.default.currentBoardIndex);
            }, false);
        });
        card.appendChild(title);
        var moveUpBtn = document.createElement("button");
        moveUpBtn.appendChild(DOM.createSVG(DOM.svgArrowsPaths[0]));
        moveUpBtn.classList.add("moveUpBtn");
        DOM.moveCardListener(moveUpBtn);
        card.appendChild(moveUpBtn);
        var moveDownBtn = document.createElement("button");
        moveDownBtn.appendChild(DOM.createSVG(DOM.svgArrowsPaths[2]));
        moveDownBtn.classList.add("moveDownBtn");
        DOM.moveCardListener(moveDownBtn);
        card.appendChild(moveDownBtn);
    };
    return DOM;
}());
exports.default = DOM;
(function () {
    DOM.currentBoard = document.querySelector(".currentBoard");
    DOM.sidebar = document.querySelector(".sidebar");
    DOM.svgArrowsPaths = [
        // up, right, down, left
        "M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z",
        "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z",
        "M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z",
        "M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z"
    ];
    // horizontal mouse scrolling
    window.addEventListener("wheel", function (e) {
        var container = document.querySelector("main");
        if (e.deltaY > 0)
            container.scrollLeft += 100;
        else
            container.scrollLeft -= 100;
    });
    // close modal when you click outside of modal or the "X" button
    var modalWrapper = document.querySelector(".modalWrapper");
    modalWrapper.addEventListener("click", function (e) {
        if (e.target === modalWrapper) {
            modalWrapper.style.display = "none";
        }
    });
    // modal - close modal button
    var closeBtn = modalWrapper.querySelector(".close");
    closeBtn.addEventListener("click", function () {
        modalWrapper.style.display = "none";
    });
    // modal - delete card button
    DOM.modalDeleteListener();
    // modal - dynamic input for title
    DOM.modalTitleListener();
    // textarea automatic resizing
    var modalTextarea = document.querySelector("textarea.description");
    modalTextarea.addEventListener("focus", function () {
        function resize() {
            modalTextarea.style.height = "";
            modalTextarea.style.height = "".concat(modalTextarea.scrollHeight + 6, " + \"px\"");
        }
        // initial resize on focus
        resize();
        // resize automatically when typing
        modalTextarea.oninput = function () {
            resize();
        };
    });
    // show sidebar when button is clicked
    var hamburgerBtn = document.querySelector("button.burger");
    var sidebar = document.querySelector(".sidebar");
    hamburgerBtn.addEventListener("click", function () {
        sidebar.classList.remove("hidden");
    });
    // hide sidebar when you click somewhere else
    DOM.currentBoard.addEventListener("click", function () {
        sidebar.classList.add("hidden");
    });
    // hide/show sidebar by swiping on phone
    DOM.sidebarSwipeListener();
})();
